// **********************************************************
// Related Items
// **********************************************************

const relatedItemsSlider = document.querySelectorAll('[data-slider="related-items-slider"]');

const relatedItemsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      spaceBetween: 14,
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1024: {
      spaceBetween: 24,
      slidesPerView: 3,
      slidesPerGroup: 2,
    },
    1439: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 2,
    },
  },
};

const initRelatedItemsSlider = () => {
  relatedItemsSlider.forEach((el) => {
    const parentEle = el.closest('[data-slider-parent]');
    const arrowRight = parentEle.querySelector('.arrow-right');
    const arrowLeft = parentEle.querySelector('.arrow-left');
    relatedItemsSliderOptions.navigation.nextEl = arrowRight;
    relatedItemsSliderOptions.navigation.prevEl = arrowLeft;

    if (windowWidth() > 767) {
      new Swiper(el, relatedItemsSliderOptions);
    } else {
      enableArrowScrollSync(parentEle);
    }
  });
};

initRelatedItemsSlider();

setupResponsiveSliders({
  sliderElements: relatedItemsSlider,
  breakpoint: 767,
  initSlider: initRelatedItemsSlider,
  mobileFallback: enableArrowScrollSync,
  parentSelector: '[data-slider-parent]',
});
